<div class="title-answer">{{supportParametric.description}}</div>

<cdk-accordion class="accordion">
<div *ngFor="let objet of supportParametric.supportQuestions; track objet; let index"> 
    <cdk-accordion-item
        #accordionItem="cdkAccordionItem"
        class="accordion-item"
        role="button"
        tabindex="0"
        [attr.id]="'accordion-header-' + index"
        [attr.aria-expanded]="accordionItem.expanded"
        [attr.aria-controls]="'accordion-body-' + index">
        <div class="accordion-item-header" (click)="accordionItem.toggle()">
          {{ objet.description }}
          <span class="accordion-item-description">
            Click to {{ accordionItem.expanded ? 'close' : 'open' }}
            <span *ngIf="!accordionItem.expanded" class="material-icons ">keyboard_arrow_down</span>
            <span *ngIf="accordionItem.expanded" class="material-icons">keyboard_arrow_up</span>
          </span>
        </div>
        <div
          class="accordion-item-body"
          role="region"
          [style.display]="accordionItem.expanded ? '' : 'none'"
          [attr.id]="'accordion-body-' + index"
          [attr.aria-labelledby]="'accordion-header-' + index">
          <div *ngFor="let objetans of objet.answers">  {{objetans.description}} </div>
        </div>
      </cdk-accordion-item>
    
</div>
</cdk-accordion>